export default __webpack_public_path__ + "static/0061-aeb190e52fd4da9f917ae24589d70dfd.png";